import React, { useEffect, createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Meta Pixel initialization - heavily deferred
function AppWithPixel() {
  useEffect(() => {
    // Defer Meta Pixel initialization until after page is fully interactive
    const initPixel = () => {
      if ((window as any).fbq) {
        ;
        (window as any).fbq('init', '752017830664443');
        (window as any).fbq('track', 'PageView');
        return;
      }
      const fbq: any = function () {
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, arguments);
        } else {
          fbq.queue.push(arguments);
        }
      };
      (window as any).fbq = fbq;
      (window as any)._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.onload = () => {
        fbq('init', '752017830664443');
        fbq('track', 'PageView');
      };
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      }
    };
    // Defer pixel by 2 seconds to prioritize page load
    setTimeout(initPixel, 2000);
  }, []);
  return <App data-id="element-304" />;
}
render(<AppWithPixel data-id="element-305" />, document.getElementById('root'));